import {watchAnimations} from '../utility/init-gsap';

class TD_POST_FEED {
  constructor(feedEl) {
    this.setBlockElements(feedEl);
    
    this.setQueryVarsOnLoad();

    this.watchEvents();

    this.layout = this.els.feedWrap.dataset.layout ? this.els.feedWrap.dataset.layout : 'grid'; // Default to grid layout
  }

  setBlockElements(feedEl) {
    this.els = {};
    this.els.block = feedEl;
    this.els.feedWrap = this.els.block.querySelector('.post_feed__list');
    this.els.loadMoreButton = this.els.block.querySelector('.post_feed__load_more');
    this.els.filterButtons = this.els.block.querySelectorAll('.post_feed__filters_btn');
    this.setCardElements();
  }

  /**
   * Set Card Elements
   */
  setCardElements(){
    this.els.cards = this.els.feedWrap.querySelectorAll('.post_card');
  }

  setQueryVarsOnLoad() {
    this.originalQueryVars = this.els.block.dataset; // Keep track of the original state
    this.queryVars = { ...this.els.block.dataset }; // Available for manipulation
  
    // For taxonomy queries, split data-attribute strings into array by the ':' characater
    if(this.queryVars.taxQueryTaxonomies){
      this.queryVars.taxQueryTaxonomies = this.queryVars.taxQueryTaxonomies.split(':');
      this.queryVars.taxQueryTerms = this.queryVars.taxQueryTerms.split(':');
    }
    else {
      this.queryVars.taxQueryTaxonomies = [];
      this.queryVars.taxQueryTerms = [];
    }

  }

  setTaxQueryVars(taxonomy, term) {
    // If the taxonomy is not set, return
    if(!taxonomy || !term){
      return;
    }

    // If the taxonomy is already set and we're replacing it, or removing it
    const taxonomyIndex = this.queryVars.taxQueryTaxonomies.indexOf(taxonomy);
    if(taxonomyIndex !== -1){
      // If it's set with the same value as the term, remove it
      if(this.queryVars.taxQueryTerms.find(t => t === term)){
        this.queryVars.taxQueryTaxonomies = this.queryVars.taxQueryTaxonomies.filter(t => t !== camelToKebabCase(taxonomy));
        this.queryVars.taxQueryTerms = this.queryVars.taxQueryTerms.filter(t => t !== term);
      }
      // Else, if it's set to 'all'
      else if(term === 'all'){
        this.queryVars.taxQueryTaxonomies.splice(taxonomyIndex, 1);
        this.queryVars.taxQueryTerms.splice(taxonomyIndex, 1);
      }
      // Otherwise, replace it with the new term
      else {
        this.queryVars.taxQueryTerms[taxonomyIndex] = term;
      }
    }
    // Else, set it and the new term
    else {
      if(Array.isArray(this.queryVars.taxQueryTaxonomies)){
        this.queryVars.taxQueryTaxonomies.push(taxonomy);
        this.queryVars.taxQueryTerms.push(term);
      }
      else {
        this.queryVars.taxQueryTaxonomies = [taxonomy];
        this.queryVars.taxQueryTerms = [term];

        // console.log what type this.queryVars is
        console.log('queryVars is not an array', this.queryVars);
      }
    }

    // Update the URL with query params for the taxonomy and term split by ':'
    const url = new URL(window.location.href);
    if(this.queryVars.taxQueryTaxonomies.length && this.queryVars.taxQueryTerms.length){
      url.searchParams.set('tax', this.queryVars.taxQueryTaxonomies.join(':'));
      url.searchParams.set('terms', this.queryVars.taxQueryTerms.join(':'));
    }
    else {
      url.searchParams.delete('tax');
      url.searchParams.delete('terms');
    }
    window.history.replaceState({}, '', url.toString());
  }

  watchEvents(){
    if(this.els.loadMoreButton){
      this.els.loadMoreButton.addEventListener('click', () => {
        this.ajaxLoadMore(true);
      });
    }

    if(this.els.filterButtons && this.els.filterButtons.length){
      this.els.filterButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          const term = button.dataset.term ? button.dataset.term : 'all';
          
          // Toggle active state
          // if(term !== 'all'){
            button.classList.toggle('active');
          // }

          // if active
          if(button.classList.contains('active') || term === 'all'){
            // Unset any other buttons
            this.els.filterButtons.forEach(btn => {
              if(btn !== button){
                btn.classList.remove('active');
              }
            });
          }
          this.setTaxQueryVars(button.dataset.taxonomy, term);
          this.ajaxLoadMore(false);
        });
      });
    }
  }

  /*****************************************************
   * AJAX CALL
   *****************************************************/
  ajaxLoadMore(loadMore = false) {
    // If we're not loading more posts but instead filtering posts, 
    // start a new query.
    if(!loadMore){
      this.queryVars.offset = 0;
    }
    else {
      this.queryVars.offset = this.els.cards.length;
    }

    var data = {
      action: 'ajax_filter_posts', // function to execute
      afp_nonce: afp_vars.afp_nonce, // wp_nonce
      queryVars: this.queryVars, // data used to execute new wp_query
      layout: this.layout, // layout type
    };

    document.body.classList.add('ajax_loading_posts');

    document.body.insertAdjacentHTML('beforeend','<div class="lds-ellipsis__wrap"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');

    console.log(this.queryVars);

    jQuery.post(afp_vars.afp_ajax_url, data, (response) => {
      if (response) {
        console.log(response);

        // Update cards markup
        if(response.data.cards){
          // If the no results message is present, remove it.
          if(this.els.noResults){
            this.els.noResults.remove(); 
            this.els.noResults = null;
          }

          // Add new cards
          if(loadMore){
            this.els.feedWrap.insertAdjacentHTML( 'beforeend', response.data.cards );
          }
          else {
            this.els.feedWrap.innerHTML = response.data.cards;
          }
          
          // Track cards
          this.setCardElements();
          
          // For better keyboard accessibility, set focus on the "next" card, 
          // or first one if we're replacing all cards.
          const focusCard = this.queryVars.offset > 0 ? this.els.cards[this.queryVars.offset - 1] : this.els.cards[0];
          const focusCardLinks = focusCard ? focusCard.querySelectorAll('a') : null;
          if(focusCardLinks && focusCardLinks.length > 0){
            const focusLink = this.queryVars.offset > 0 ? focusCardLinks[focusCardLinks.length - 1] : focusCardLinks[0];
            focusLink.focus();
            focusLink.blur();
          }

          if(this.els.feedWrap.classList.contains('hidden')){
            this.els.feedWrap.classList.remove('hidden');
          }
        }
        else if(response.data.noResultsMarkup && !this.el.noResults) {
          this.els.feedWrap.innerHTML = '';
          this.els.block.insertAdjacentHTML('beforeend', response.data.noResultsMarkup);
          this.els.noResults = this.els.block.querySelector('.post_feed__no_results');
          this.setCardElements();
        }

        // Update the offset of the query vars
        this.queryVars.offset = this.els.cards.length ? this.els.cards.length : 0;

        // Determine if we should show/hide the load more button
        if(this.els.loadMoreButton){
          if(this.els.cards.length >= response.data.totalCount){
            this.els.loadMoreButton.setAttribute('disabled', '');
          }
          else if(this.els.loadMoreButton.getAttribute('disabled') !== null){
            this.els.loadMoreButton.removeAttribute('disabled');
          }
        }
      }
    }).done(() => {
    }).fail(() => {
    }).always(() => {
      document.body.classList.remove('ajax_loading_posts');
      const loadingGraphic = document.querySelector('.lds-ellipsis__wrap');
      loadingGraphic.remove();

      // Call window resize event to trigger scroll trigger animations if needed
      setTimeout(() => {
        watchAnimations();
        const event = new CustomEvent("resize");
        window.dispatchEvent(event);
      }, 100);
    });
  }
}

export const initializePostFeeds = (event) => {
  const feeds = document.querySelectorAll('.post_feed');
  if(feeds.length){
    feeds.forEach(feed => {
      feed.postFeed = new TD_POST_FEED(feed);
    });
  }
};

function camelToKebabCase(str) {
  return str
    // Replace any lowercase letter followed by an uppercase letter with the lowercase letter, a hyphen, and the uppercase letter
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    // Convert the whole string to lowercase
    .toLowerCase();
}

function camelToUnderscoreCase(str) {
  return str
    // Replace any lowercase letter followed by an uppercase letter with the lowercase letter, a hyphen, and the uppercase letter
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    // Convert the whole string to lowercase
    .toLowerCase();
}